/**
 * ProgressIndicator component for displaying assessment progress
 */
import React from 'react';

interface ProgressIndicatorProps {
  currentStep: number;
  totalSteps: number;
  labels?: string[];
}

const ProgressIndicator: React.FC<ProgressIndicatorProps> = ({ 
  currentStep, 
  totalSteps,
  labels 
}) => {
  const percentage = Math.round((currentStep / totalSteps) * 100);
  
  return (
    <div className="w-full space-y-2">
      <div className="flex justify-between text-sm text-gray-600">
        <span>Question {currentStep} of {totalSteps}</span>
        <span>{percentage}% Complete</span>
      </div>
      
      <div className="h-2 w-full bg-gray-200 rounded-full overflow-hidden">
        <div 
          className="h-full bg-deepBlue transition-all duration-300 ease-in-out" 
          style={{ width: `${percentage}%` }}
        />
      </div>
      
      {labels && (
        <div className="flex justify-between mt-2">
          {labels.map((label, index) => {
            const isActive = index < currentStep;
            const isCurrent = index === currentStep - 1;
            
            return (
              <div 
                key={index}
                className={`flex flex-col items-center ${isActive ? 'text-deepBlue' : 'text-gray-400'}`}
                style={{ width: `${100 / labels.length}%` }}
              >
                <div 
                  className={`w-4 h-4 rounded-full mb-1 ${
                    isCurrent 
                      ? 'bg-deepBlue ring-2 ring-deepBlue/30' 
                      : isActive 
                        ? 'bg-deepBlue' 
                        : 'bg-gray-300'
                  }`}
                />
                <span className="text-xs text-center">{label}</span>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default ProgressIndicator;
